import React from 'react';

import {
    Footer,
    Meta,
    Navigation,
} from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ErrorPage}
 */

const ErrorPage = ({ data: rawData, domain, err }) => {
    const data = /** @type {Record<string, any>} */ (rawData);
    const status = err?.status || 500;
    const message = err?.message || 'Sorry, something went wrong.';

    const title = status === 404 ? 'Page not found' : 'Something went wrong';
    const description = status === 404
        ? 'The page you\'re looking for doesn\'t exist or has been moved.'
        : message;

    return (
        <>
            <Meta page={{ pageTitle: title }} />
            <Navigation navigation={data?.navigation} />

            <main id='main-content'>
                <div className='min-h-screen'>
                    <section className='layout-container layout-site-outer-padding flex flex-col pb-24 pt-[116px] sm:pt-[108px] md:pt-[160px]'>
                        <h1 className='type-style-3-extended text-text-primary'>
                            {title}
                        </h1>

                        <p className='text-text-secondary type-style-body mt-10 md:mt-16 sm:w-10/12 md:w-6/12'>
                            {description}
                        </p>
                    </section>

                    <div className='pt-8'>
                        <Footer
                            domain={domain}
                            menu={data?.footer} />
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ErrorPage;
